export default {
  day: 'Day',
  delete: 'Delete',
  details: 'Details',
  dnsName: 'DNS Name',
  down: 'Down',
  duration: 'Duration'
}
